import { lazy } from 'react';
import { Navigate, RouteObject } from 'react-router-dom';
import { ModuleGuard } from '@shared/module-kit';

const CapacityPlanningPage = lazy(() => import('./pages/CapacityPlanningPage'));
const ResourceLevelingPage = lazy(() => import('./pages/ResourceLevelingPage'));
const BenchTrackingPage = lazy(() => import('./pages/BenchTrackingPage'));
const SkillsMatrixPage = lazy(() => import('./pages/SkillsMatrixPage'));
const TrainingDevelopmentPage = lazy(() => import('./pages/TrainingDevelopmentPage'));

export const ResourcesRoutes: RouteObject = {
  path: 'resources',
  handle: { crumb: 'Resource Planning & Talent' },
  element: <ModuleGuard moduleId="projects.resources" />,
  children: [
    { index: true, element: <Navigate to="capacity-planning" replace /> },
    { path: 'capacity-planning', element: <CapacityPlanningPage />, handle: { crumb: 'Capacity Planning' } },
    { path: 'resource-leveling', element: <ResourceLevelingPage />, handle: { crumb: 'Resource Leveling' } },
    { path: 'bench-tracking', element: <BenchTrackingPage />, handle: { crumb: 'Bench Tracking' } },
    { path: 'skills-matrix', element: <SkillsMatrixPage />, handle: { crumb: 'Skills Matrix' } },
    { path: 'training-development', element: <TrainingDevelopmentPage />, handle: { crumb: 'Training Development' } },
  ],
};
